module.exports = __webpack_public_path__ + "img/chefs_2.b8bf54b2.png";